const getters = {
    entities: (state) => state.entities,
    selectedEntity: (state) => state.selectedEntity,
    isEntitiesWithAttributesLoaded: state => state.isEntitiesWithAttributesLoaded,
    sibTrackingRemainingDay: (state) => state.sibTrackingRemainingDay
}
export default getters;